import { render, staticRenderFns } from "./AddFileModalContent.vue?vue&type=template&id=1c35c696"
import script from "./AddFileModalContent.vue?vue&type=script&lang=js"
export * from "./AddFileModalContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports